module.exports = __webpack_public_path__ + "static/img/right-icon.f370308f.png";